// @ts-strict-ignore
import { createReducer, on } from "@ngrx/store";
import { ProblemDetails } from "src/app/api/models";
import { AppActions } from "./app.actions.types";

export interface AppState {
  pageName: string;
  blockui: boolean;
  blockuiCounter: number;
  hideSpinnerAfterUnBlock: boolean;
  spinner: boolean;
  spinnerType: string;
  showHttpError: boolean;
  httpErrorDescription: string;
  httpErrorDetails: ProblemDetails | null;
  toastSeverity: string;
  toastDetail: string;
  dialogHeader: string;
  dialogContent: string;
}

export const defaultState: AppState = {
  pageName: "",
  blockui: false,
  blockuiCounter: 0,
  hideSpinnerAfterUnBlock: false,
  spinner: false,
  spinnerType: "default",
  showHttpError: false,
  httpErrorDescription: "",
  httpErrorDetails: null,
  toastSeverity: null,
  toastDetail: null,
  dialogHeader: null,
  dialogContent: null
};

const normalizeProblemDetails = (details: unknown): ProblemDetails | null => {
  if (typeof details === "string") {
    return details.length > 0 ? { detail: details } : null;
  }
  if (typeof details === "object" && details !== null) {
    return details as ProblemDetails;
  }
  return null;
};

export const AppReducer = createReducer(
  defaultState,
  on(AppActions.ShowSpinner, (state, action) => {
    return {
      ...state,
      spinner: true,
      spinnerType: action?.spinnerType ?? "default"
    };
  }),
  on(AppActions.HideSpinner, (state) => {
    return {
      ...state,
      spinner: false
    };
  }),
  on(AppActions.ShowBlockUI, (state, action) => {
    if (action.showSpinner) {
      return {
        ...state,
        blockui: true,
        blockuiCounter: state.blockuiCounter + 1,
        spinner: true,
        spinnerType: action?.spinnerType ?? "default",
        hideSpinnerAfterUnBlock: true
      };
    } else {
      return {
        ...state,
        blockui: true,
        blockuiCounter: state.blockuiCounter + 1
      };
    }
  }),
  on(AppActions.HideBlockUI, (state) => {
    if (state.blockuiCounter - 1 <= 0) {
      if (state.hideSpinnerAfterUnBlock) {
        return {
          ...state,
          blockui: false,
          blockuiCounter: 0,
          spinner: false,
          hideSpinnerAfterUnBlock: false
        };
      } else {
        return {
          ...state,
          blockui: false,
          blockuiCounter: 0
        };
      }
    } else {
      return {
        ...state,
        blockuiCounter: state.blockuiCounter - 1
      };
    }
  }),
  on(AppActions.SetPageName, (state, action) => {
    return {
      ...state,
      pageName: action.name
    };
  }),
  on(AppActions.ShowAbout, (state) => {
    return {
      ...state,
      showAbout: true
    };
  }),
  on(AppActions.HideAbout, (state) => {
    return {
      ...state,
      showAbout: false
    };
  }),
  on(AppActions.ShowEsimLookup, (state) => {
    return {
      ...state,
      showEsimLookup: true
    };
  }),
  on(AppActions.HideEsimLookup, (state) => {
    return {
      ...state,
      showEsimLookup: false
    };
  }),
  on(AppActions.ShowHttpError, (state, action) => {
    return {
      ...state,
      showHttpError: true,
      httpErrorDescription: action?.httpErrorDescription ?? "",
      httpErrorDetails: normalizeProblemDetails(action?.httpErrorDetails),
      blockui: false,
      spinner: false
    };
  }),
  on(AppActions.HideHttpError, (state) => {
    return {
      ...state,
      showHttpError: false,
      httpErrorDescription: "",
      httpErrorDetails: null,
      blockui: false,
      spinner: false
    };
  }),
  on(AppActions.ShowToastMessage, (state, action) => {
    return {
      ...state,
      toastSeverity: action.severity,
      toastDetail: action.detail
    };
  }),
  on(AppActions.ClearToastMessage, (state) => {
    return {
      ...state,
      toastSeverity: null,
      toastDetail: null
    };
  }),
  on(AppActions.ShowDialogMessage, (state, action) => {
    return {
      ...state,
      dialogHeader: action.header,
      dialogContent: action.content
    };
  }),
  on(AppActions.ClearDialogMessage, (state) => {
    return {
      ...state,
      dialogHeader: null,
      dialogContent: null
    };
  })
);
